import { Outlet, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export default function LayoutHeader() {
  return (
    <div className="h-screen w-screen flex flex-col">
      <div className="flex flex-row items-center bg-[#22398E] justify-between shadow-lg w-full h-24 px-4 md:px-8 flex-shrink-0">
        <Logo classImg="h-14 w-auto md:h-18 md:w-60 object-contain" />
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
